// React imports
import React from 'react';

// Third-party imports
import { useSelector } from 'react-redux';

import { getProjects } from 'src/redux/features/session/slice';
import { Select } from 'antd';
import en from 'src/messages/en.json';

export const ProjectsAutoComplete = ({
  onSelectedProjectChange,
  style,
  selectedProject,
  selectedTargetProjectId,
}: {
  onSelectedProjectChange: any;
  style: any;
  selectedProject?: any;
  selectedTargetProjectId?: number | undefined;
}) => {
  const { data: projects } = useSelector(getProjects);
  const filteredProjects = selectedProject
    ? projects.filter((val) => val.name != selectedProject)
    : projects;

  const projectOptions = filteredProjects.map((proj) => ({
    label: proj.name,
    value: proj.id,
  }));
  const handleChange = (projectId: number) => {
    const selected = projects.find((proj) => proj.id === projectId);

    onSelectedProjectChange(selected ?? null);
  };

  return (
    <Select
      showSearch
      placeholder={en.Common.Placeholder.default}
      style={style}
      value={selectedTargetProjectId ?? undefined}
      onChange={handleChange}
      options={projectOptions}
      filterOption={(input, option) =>
        option?.label?.toString().toLowerCase().includes(input.toLowerCase())
      }
      allowClear
      showArrow={true}
    />
  );
};

export default ProjectsAutoComplete;
